export default "__VITE_ASSET__B3ln4JWe__"